import type { FaireProductEntity } from "../../entity_types/product";

export const p_ez73rhp4bd: FaireProductEntity = {
  token: "p_ez73rhp4bd",
  type: "product",
  name: "Gold and Crystal Stacking Ring Set",
  brandToken: "b_k2cxrcr92s",
  brandName: "Frem",
  imageUrl:
    "https://cdn.faire.com/fastly/f2b96aa6249a1d6380a1f9f70e3b5a5ec4fae88c4eb82c7858a9926a4eea0348.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/28d0931f3a681892532f538731816dbf7690772a2f0cf86cdf0555e5eb9b137c.jpeg",
  ],
  priceDollars: 7.62,
  description:
    "This elegant ring set includes three gold tone stacking bands featuring a mix of styles—one with clear baguette crystals, one with dainty faux pearls, and one with a bold sculptural design. Made for versatility, these rings can be worn individually or layered for a curated look. Perfect for boutiques and gift shops seeking stylish, easy to merchandise accessories with broad customer appeal.\n\n\n\n\n",
  tags: [],
  msrpDollars: 22.86,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:57.240Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
